<div class="bottom-sheet-overlay">
    <div #bottomSheetBackdrop class="cdk-overlay-backdrop cdk-overlay-dark-backdrop bottom-sheet-backdrop"></div>
    <div #bottomSheetContainer class="bottom-sheet-container mat-dialog-container">
    <ng-container #bottomSheetNgContainer></ng-container>
</div>
</div>